import useSWR from 'swr';

import { ENDPOINTS } from '@/api/endpoints';
import { getIndications } from '@/api/indications';

const mapIndications = (indications: Record<string, { indication: string; methods: string }>) => {
  return Object.entries(indications).map(([id, { indication, methods }]) => ({
    id,
    indication,
    methods: Object.values(methods),
  }));
};

export const useGetIndications = ({ site_id }: { site_id?: string }) => {
  const { data, isLoading, mutate } = useSWR(site_id && [ENDPOINTS.CLINICS, site_id], () =>
    getIndications({ site_id })
  );

  return {
    loading: isLoading,
    indications: mapIndications(data ?? {}),
    refetch: mutate,
  };
};
